import React from 'react';
import { AppBar as _AppBar } from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

import UserMenu from './UserMenu';
/* import Logo from './Logo'; */

const useStyles = makeStyles({
    title: {
        flex: 1,
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    spacer: {
        flex: 1,
    },
});

const AppBar = props => {
    const classes = useStyles();
    return (
        <_AppBar {...props}
            open={false}
            userMenu={<UserMenu />}
        >
            {/*
            <Typography
                variant="h6"
                color="inherit"
                className={classes.title}
                id="react-admin-title"
            />
            */}
            {/*<Logo />*/}
            <span className={classes.spacer} />
        </_AppBar>
    );
};

export default AppBar;